
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { compose } from 'recompose';
import styled from 'styled-components';
import { hot } from 'react-hot-loader';
import { Link } from 'react-router-dom';
import { Button, Card, List, Icon, Label, Header } from 'semantic-ui-react';
import { withLanguageID } from 'op/components/locale';
import { withLocale } from 'op/components/locale';
import { withPendingReports } from './report-pending.helper';
import imgAdobe from '../../assets/imgAdobe.png'
import ReportDeleteModal from 'op/components/report/delete-modal';
import axios from "axios";
import { withPendingStpForms } from './stp-form-pending.helper';




const PendingItem = ({ people, report, locale, downloadReport, language, deleteReport, online, dateFormat }) => (

	<List.Item key={report.id}>
		{
			report.dirty &&
			<List.Content floated='right'>
				<Label content={`(${report.dirty.length}) change${report.dirty.length == 1 ? '' : 's'}`} />
			</List.Content>
		}
		<Icon name="tasks" />


		<List.Content>
			<List.Header as={Link} to={`/person/${report.person_id}/report/${report.id}/edit`}>
				{report.id} - {people.find(person => person.id === report.person_id).name}
			</List.Header>

			<List.Description>
				{`${report.category && report.type.name} - ${report.categoriesArr}`}
			</List.Description>
			<List.Description>
				{`${locale.doc}  -  ${moment(report.timestamp).format(dateFormat)}`}
			</List.Description>
			<List.Description>
				{`${locale.pid} - ${people.find(person => person.id === report.person_id).id}`}
			</List.Description>
			<List.Description>
				{`${locale.dob}  -  ${moment(people.find(person => person.id === report.person_id).birthday).format(dateFormat)}`}
			</List.Description>
			<List.Description>
				<ReportDeleteModal online={online} onDelete={() => deleteReport(report)} />
			</List.Description>
			<List.Description>
				{online ?
					<a component='button' onClick={() => downloadReport(report, people.find(person => person.id === report.person_id), language)}>{locale.savePdf}  <img src={imgAdobe} style={{ width: 20 }} /></a>
					: <a component='button'>{locale.savePdf}  <img src={imgAdobe} style={{ width: 20 }} /></a>
				}
			</List.Description>

		</List.Content>
	</List.Item>
);

const HistoryItem = ({ people, report }) => (
	<List.Item key={report.lastUpdateTime}>
		<Icon name="check" />
		<List.Content>
			<List.Header as={Link} to={`/person/${report.person_id}/report/${report.id}`}>
				{report.id} - {people.find(person => person.id === report.person_id).name}
			</List.Header>
			<List.Description>
				{`${report.category && report.category.name}  -  ${report.category && report.type.name}`}
			</List.Description>
		</List.Content>
	</List.Item>
);

const StpPendingItem = ({ data, item, id, lastUpdateTime, locale, remove, online }) => {
	const isSigned = data[0].STPMainSig && data[0].STPMainSig.length > 0;
	const readableDateTime = moment(lastUpdateTime).format('DD/MM/YYYY HH:mm');
	const itemName = item.item_Name;
	const itemSerial = item.item_Serial;
	const itemModel = item.item_Model;
	const itemLocation = item.item_Location;

	const href = `/stp/${item.item_ID}/tests/${id}/edit`;

	return (
		<List.Item key={id}>
			<List.Content floated='right'>
				<Label content={readableDateTime} />
			</List.Content>
			<Icon name="tasks" />
			<List.Content>
				<List.Header as={Link} to={href}>
					{`${itemName} - ${itemSerial} - ${itemModel} - ${itemLocation}`}
				</List.Header>
				<List.Description>
					{`${isSigned ? locale.signed : locale.notSigned}`}
				</List.Description>
			</List.Content>
			<List.Description>
				<ReportDeleteModal onDelete={remove} online={online} isStp />
			</List.Description>
		</List.Item>
	);
}


const ReportListCard = ({ reports, title, children }) => (
	<Card fluid style={{ padding: '1rem 3rem 3rem 3rem' }}>
		<Card.Content>
			<Card.Header content={title} />
			<List divided verticalAlign='middle'>
				{reports && reports.filter(report => !!report).sort((left, right) => moment(right.lastUpdateTime).diff(left.lastUpdateTime)).map((report, index) => children({ report, index }))}
			</List>
		</Card.Content>
		<Label attached='bottom' content={reports && `Count: ${reports.length}`} />
	</Card>
);


const EmptyPage = styled.div`
	display: flex;

	height: 100%;
	width: 100%;

	align-items: center;
	justify-content: center;

	padding-top: 2rem;
`;

const PendingReports = ({ stpRemoveFromPending, stpEditing, locale, pending, history, people, categories, downloadReport, language, online, deleteReport }) => {
	const [fieldValue, setFieldValue] = useState();
	useEffect(() => {
		setFieldValue("DD/MM/YYYY");
		axios.get('/api/common/terms').then(response => {
			setFieldValue(response.data.dateConvertCode == 103 ? "DD/MM/YYYY" : "MM/DD/YYYY");
		}).catch(ex => console.log(ex.message));
	}, []);
	return (
		<Card.Group>
			{
				pending && pending.length > 0 &&
				<ReportListCard title={locale.pending} reports={pending} >
					{({ report }) => <PendingItem key={report.id} language={language} downloadReport={downloadReport} people={people} report={report} locale={locale} categories={categories} online={online} dateFormat={fieldValue} deleteReport={deleteReport} />
					}
				</ReportListCard>

			}
			{
				history && history.length > 0 &&
				<ReportListCard title={locale.history} reports={history}>
					{({ report }) => <HistoryItem key={report.id} people={people} report={report} />}
				</ReportListCard>
			}
			{
				stpEditing && stpEditing.length > 0 &&
				<Card fluid style={{ padding: '1rem 3rem 3rem 3rem' }}>
					<Card.Content>
						<Card.Header content={locale.stpPending} />
						<List divided verticalAlign='middle'>
							{stpEditing && stpEditing.length > 0 && stpEditing.map((item, index) => <StpPendingItem key={index} data={item.data} item={item.item} id={item.id} lastUpdateTime={item.lastChangeTime} locale={locale} remove={() => stpRemoveFromPending(item.id)} online={online} />)}
						</List>
					</Card.Content>
					<Label attached='bottom' content={stpEditing && `Count: ${stpEditing.length}`} />
				</Card>
			}
			{
				!((pending && pending.length > 0) || (history && history.length > 0)) && (!stpEditing || stpEditing.length == 0) &&
				<EmptyPage>
					<Header as='h2' icon>
						<Icon name='space shuttle' />
						{locale.empty.header}
						<Header.Subheader>{locale.empty.content}</Header.Subheader>
					</Header>
				</EmptyPage>
			}
		</Card.Group>
	)
};

export default compose(
	withLocale('report.pending'),
	withPendingReports,
	withPendingStpForms,
	withLanguageID,
	hot(module),
)(PendingReports)